import { useMemo } from 'react';
import { ReactNode } from '@tanstack/react-router';
import { OverlayedLoader } from '@mews-commander/ui';
import { createSafeContext, useToggle } from '@mews/framework';

interface LoaderContextProps {
    toggleShowLoader: () => void;
}

export const { LoaderContextProvider: ContextProvider, useLoaderContext } = createSafeContext<
    'LoaderContext',
    LoaderContextProps
>('LoaderContext');

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
    const [showLoader, toggleShowLoader] = useToggle();

    const contextValue = useMemo(
        () => ({
            toggleShowLoader,
        }),
        [toggleShowLoader]
    );

    return (
        <ContextProvider value={contextValue}>
            <OverlayedLoader show={showLoader} />
            {children}
        </ContextProvider>
    );
};
